import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodyXs } from "@/domains/design/components/body-xs"

interface WithdrawNotExpiredProps {
  store: WithdrawStore
}

export const WithdrawNotExpired = observer(({ store }: WithdrawNotExpiredProps) => {
  if (!store.lock) return null

  return (
    <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodyXs className="text-t200">This veSCALE will be ready for withdraw on {store.lock.displayLockEnds}.</BodyXs>
    </ShortMessageBox>
  )
})
